export default __webpack_public_path__ + "static/media/sugar_001.45d302ad.jpg";